"use client";

import { c as _c } from "react/compiler-runtime";
import { LandvestHandoffLink } from "@/components/layout/LandvestHandoffLink";
import type { MegaMenuSection } from "@/lib/navigation";
interface MegaMenuChipsProps {
  chips: NonNullable<MegaMenuSection["chips"]>;
  onItemClick: () => void;
}

/** A labelled row of pill links under a menu column, e.g. "Nach Branche". */
export function MegaMenuChips(t0) {
  const $ = _c(12);
  const {
    chips,
    onItemClick
  } = t0;
  let t1;
  if ($[0] !== chips.title) {
    t1 = <span className="text-xs font-semibold text-on-surface-variant">{chips.title}</span>;
    $[0] = chips.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== chips.links || $[3] !== onItemClick) {
    let t3;
    if ($[5] !== onItemClick) {
      t3 = link => <LandvestHandoffLink key={link.href} href={link.href} onClick={onItemClick} role="menuitem" className="text-[13px] font-semibold text-primary px-3 py-1.5 rounded-full border border-primary/20 hover:border-secondary hover:text-secondary transition-colors">{link.label}</LandvestHandoffLink>;
      $[5] = onItemClick;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = chips.links.map(t3);
    $[2] = chips.links;
    $[3] = onItemClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="flex flex-wrap gap-2">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className="flex flex-col gap-2.5 pt-1.5">{t1}{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}